import { initResponsiveSlidesCarousel } from '../responsive-slides-carousel'

export function initEventsWhatWeOfferCarousel(): void {
  const $carouselElement = document.getElementById('events-what-we-offer-carousel')

  initResponsiveSlidesCarousel($carouselElement)
}
